/**
 * Gate-ops shell (Wave D) — GUARD and FRONTDESK land here; anyone else is
 * bounced to their own home. One app, role-gated shells.
 */
import { Redirect, Stack } from 'expo-router';
import React from 'react';

import { homeFor } from '@/lib/homeFor';
import { useSession } from '@/lib/session';
import { useTheme } from '@/theme';
import { Screen, Skeleton } from '@/ui';

export default function GuardLayout() {
  const { user, loading } = useSession();
  const { colors } = useTheme();

  if (loading) {
    return (
      <Screen scroll={false} padded style={{ justifyContent: 'center', gap: 12 }}>
        <Skeleton h={22} w="60%" />
        <Skeleton h={16} w="90%" />
      </Screen>
    );
  }
  if (!user) return <Redirect href="/login" />;
  if (user.role !== 'GUARD' && user.role !== 'FRONTDESK') {
    return <Redirect href={homeFor(user) as '/(tabs)/home'} />;
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.canvas0 },
      }}
    />
  );
}
